import React, { useState } from "react";
import { Phone, MapPin, Clock, Menu, X } from "lucide-react";
import logo from "./assets/logo3.jpeg";
import doctorImage from "./assets/dotor_image.jpg";
import clinicImage from "./assets/clinic_image.jpeg";
import clinicArea1 from "./assets/Clinic Area 1.jpeg";
import clinicArea2 from "./assets/clinic area 2.jpeg";
import clinicArea4 from "./assets/clinic area 4.jpeg";
import entrence from "./assets/entrence.jpeg";
import doctorDesk from "./assets/doctor desk.jpeg";
import receptionDesk from "./assets/reception desk.jpeg";
import waitingArea from "./assets/waiting area lounge.jpeg";
import imgCleaning from "./assets/cleaning_polishing.jpg";
import imgCrown from "./assets/crown_and_bridge.jpg";
import imgDentures from "./assets/dentures.jpg";
import imgPediatric from "./assets/pediatric_dentistry.jpg";
import imgRootCanal from "./assets/root_canal.jpg";
import imgImplant from "./assets/implant.jpg";
import imgExtraction from "./assets/extraction.jpg";
import imgOrtho from "./assets/Orthopedic_treatment.jpg";
import { SiInstagram, SiFacebook, SiWhatsapp } from "@icons-pack/react-simple-icons";

// --- Components ---

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { href: "#about", label: "About" },
    { href: "#services", label: "Services" },
    { href: "#gallery", label: "Gallery" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <a href="/" className="flex items-center">
            <img src={logo} alt="Hello Dentist Logo" className="h-12 w-auto mr-3 object-contain" />
            <span className="text-2xl font-bold text-teal-900 tracking-tight">Hello Dentist</span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="text-gray-600 hover:text-teal-600 font-medium transition-colors">
                {link.label}
              </a>
            ))}
            <a
              href="https://wa.me/919274803990"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-5 py-2.5 rounded-full font-medium hover:bg-teal-700 transition-colors shadow-md flex items-center"
            >
              <SiWhatsapp className="w-5 h-5 mr-2" />
              Book Appointment
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-teal-600 focus:outline-none">
              {isOpen ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg absolute w-full left-0">
          <div className="px-4 pt-2 pb-6 space-y-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-teal-600 hover:bg-teal-50 rounded-md"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://wa.me/919274803990"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 w-full flex items-center justify-center bg-teal-600 text-white px-5 py-3 rounded-md font-medium hover:bg-teal-700"
            >
              <SiWhatsapp className="w-5 h-5 mr-2" />
              Book Appointment
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

const Hero = () => (
  <section className="relative bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto">
      <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32 pt-16 lg:pt-24 px-4 sm:px-6 lg:px-8">
        <main className="mx-auto max-w-7xl sm:mt-12 md:mt-16 lg:mt-20 xl:mt-28">
          <div className="sm:text-center lg:text-left">
            <span className="inline-block py-1 px-3 rounded-full bg-teal-50 text-teal-700 text-sm font-semibold tracking-wide mb-4 border border-teal-100">
              Welcome to Hello Dentist - Top Dental Clinic in Vadodara
            </span>
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl mb-6">
              <span className="block xl:inline">Decoding</span>{" "}
              <span className="block text-teal-600 xl:inline">healthy smiles</span>
            </h1>
            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
              Experience the best dental care in Vadodara. From routine check-ups to advanced cosmetic dentistry, we are committed to giving you the confident smile you deserve.
            </p>
            <div className="mt-8 sm:mt-10 flex sm:justify-center lg:justify-start gap-4">
              <a
                href="https://wa.me/919274803990"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full text-white bg-teal-600 hover:bg-teal-700 md:py-4 md:text-lg md:px-10 shadow-lg hover:shadow-xl transition-all"
              >
                Book via WhatsApp
              </a>
              <a
                href="tel:9274803990"
                className="w-full flex items-center justify-center px-8 py-3 border-2 border-teal-100 text-base font-medium rounded-full text-teal-700 bg-white hover:bg-teal-50 md:py-4 md:text-lg md:px-10 transition-all"
              >
                Call Clinic
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
      <img
        className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full shadow-2xl rounded-bl-[100px]"
        src={clinicImage}
        alt="Hello Dentist - Modern dental clinic interior in Vadodara"
      />
      <div className="absolute inset-0 bg-teal-900 opacity-10 lg:rounded-bl-[100px]"></div>
    </div>
  </section>
);

const Services = () => {
  const servicesList = [
    { title: "Cleaning and Polishing", description: "Keep your teeth healthy and shining with our professional cleaning and polishing services.", image: imgCleaning },
    { title: "Crown and Bridge", description: "Restore your smile and bite with durable, natural-looking crowns and bridges.", image: imgCrown },
    { title: "Dentures", description: "Custom-made complete or partial dentures for a comfortable and confident smile.", image: imgDentures },
    { title: "Pediatric Dentistry", description: "Gentle, friendly, and specialized dental care designed exclusively for children.", image: imgPediatric },
    { title: "Root Canal Treatment", description: "Pain-free root canal therapies to save and protect damaged or infected teeth.", image: imgRootCanal },
    { title: "Dental Implant", description: "Permanent, natural-looking tooth replacements to restore missing teeth perfectly.", image: imgImplant },
    { title: "Tooth Extraction", description: "Safe and painless tooth extractions for severely damaged or problematic teeth.", image: imgExtraction },
    { title: "Orthodontic Treatment", description: "Clear aligners and braces to achieve perfectly straight teeth and a confident bite.", image: imgOrtho },
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-teal-600 font-semibold tracking-wide uppercase">Our Expertise</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Top Dental Treatments in Vadodara
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            We offer a wide range of specialized dental treatments to ensure the best outcomes for your oral health.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {servicesList.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 flex flex-col items-center text-center group">
              <div className="w-24 h-24 mb-6 overflow-hidden rounded-full border-4 border-teal-50 group-hover:border-teal-100 transition-colors">
                <img src={service.image} alt={`${service.title} at Hello Dentist Vadodara`} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const About = () => (
  <section id="about" className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
        <div className="relative mb-12 lg:mb-0">
          <div className="absolute inset-0 bg-teal-100 rounded-[2rem] transform translate-x-4 translate-y-4"></div>
          <img
            src={doctorImage}
            alt="Dr. Hetvi - Best Dentist in Vadodara"
            className="relative rounded-[2rem] shadow-xl w-full object-cover z-10 border-4 border-white"
          />
        </div>
        
        <div>
          <h2 className="text-teal-600 font-semibold tracking-wide uppercase mb-2">Meet The Best Dentist in Vadodara</h2>
          <p className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6">
            Dr. Hetvi
          </p>
          <p className="text-lg font-medium text-gray-700 mb-6 flex items-center">
            BDS <span className="mx-3 text-gray-300">|</span> PGDHM
          </p>
          <div className="space-y-5 text-lg text-gray-600 leading-relaxed">
            <p>
              Dr. Hetvi is a compassionate and highly skilled dental professional dedicated to providing exceptional patient care. With a decade of experience in dentistry, she specializes in delivering precise and effective treatments.
            </p>
            <p>
              She completed her Bachelor of Dental Surgery from the prestigious Government Dental College and Hospital Civil Ahmedabad, Gujarat. She also holds a Post Graduate Diploma in Hospital Management (PGDHM) from Gujarat University. With a patient-first approach, Dr. Hetvi focuses on creating a comfortable and trusting environment, designing personalized treatment plans for every unique smile.
            </p>
          </div>
          
          <div className="mt-10 grid grid-cols-2 gap-6">
            <div className="border-l-4 border-teal-500 pl-4">
              <p className="text-3xl font-bold text-gray-900 mb-1">9+ Years</p>
              <p className="text-sm text-gray-500 uppercase tracking-wide">Of Experience</p>
            </div>
            <div className="border-l-4 border-teal-500 pl-4">
              <p className="text-2xl font-bold text-gray-900 mb-1">GDCHA Gujarat</p>
              <p className="text-sm text-gray-500 uppercase tracking-wide">Alumnus</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Gallery = () => {
  const images = [
    { src: entrence, alt: "Clinic Entrance" },
    { src: receptionDesk, alt: "Reception Desk" },
    { src: waitingArea, alt: "Waiting Area Lounge" },
    { src: doctorDesk, alt: "Doctor's Desk" },
    { src: clinicArea1, alt: "Clinic Area 1" },
    { src: clinicArea2, alt: "Clinic Area 2" },
    { src: clinicArea4, alt: "Clinic Area 4" },
  ];

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-teal-600 font-semibold tracking-wide uppercase">Our Clinic</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Inside Our Vadodara Dental Clinic
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            Experience our modern, comfortable, and hygienic clinic environment.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {images.map((img, index) => (
            <div key={index} className="overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 group">
              <img src={img.src} alt={`${img.alt} - Hello Dentist Vadodara`} className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Contact = () => (
  <section id="contact" className="py-20 bg-teal-900 text-teal-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-teal-400 font-semibold tracking-wide uppercase">Get in Touch</h2>
        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
          Visit Hello Dentist
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        {/* Contact Info */}
        <div className="lg:col-span-1 space-y-8">
          <div className="flex items-start">
            <div className="flex-shrink-0 bg-teal-800 p-3 rounded-lg">
              <MapPin className="h-6 w-6 text-teal-400" />
            </div>
            <div className="ml-4">
              <h3 className="text-lg font-medium text-white">Location</h3>
              <p className="mt-2 text-teal-200">
                FF106 Shree Aarna Skywaves,<br />
                Opp. Sepal Recidency, Gotri,<br />
                Vadodara 390021
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="flex-shrink-0 bg-teal-800 p-3 rounded-lg">
              <Clock className="h-6 w-6 text-teal-400" />
            </div>
            <div className="ml-4">
              <h3 className="text-lg font-medium text-white">Working Hours</h3>
              <p className="mt-2 text-teal-200">Monday - Saturday<br />11:00 AM to 7:00 PM</p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="flex-shrink-0 bg-teal-800 p-3 rounded-lg">
              <Phone className="h-6 w-6 text-teal-400" />
            </div>
            <div className="ml-4">
              <h3 className="text-lg font-medium text-white">Contact</h3>
              <p className="mt-2 text-teal-200">+91 9274803990</p>
              <p className="text-teal-200">hdbyhetvi@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="lg:col-span-2">
          <div className="bg-teal-800 p-2 rounded-2xl shadow-xl h-full min-h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.9120331711833!2d73.12812617486196!3d22.319166379673078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc975d671f273%3A0xdef4536a1897c157!2sHello%20Dentist!5e0!3m2!1sen!2sin!4v1774760250335!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '1rem' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps location of Hello Dentist"
              className="w-full h-full min-h-[400px]"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer className="bg-gray-900 text-gray-300 py-6 border-t border-gray-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between">
      <div className="flex items-center space-x-3 mb-4 md:mb-0">
        <img src={logo} alt="Hello Dentist Logo" className="h-8 w-auto bg-white p-1 rounded-sm object-contain" />
        <span className="text-sm font-medium text-gray-400">
          &copy; {new Date().getFullYear()} Hello Dentist | Dr. Hetvi. All rights reserved.
        </span>
      </div>

      <div className="flex items-center space-x-6">
        <a href="https://www.instagram.com/hellodentist_drhetvi" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
          <span className="sr-only">Instagram</span>
          <SiInstagram className="h-5 w-5" />
        </a>
        <a href="https://www.facebook.com/hellodentistdrhetvi" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
          <span className="sr-only">Facebook</span>
          <SiFacebook className="h-5 w-5" />
        </a>
        <a href="https://wa.me/919274803990" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
          <span className="sr-only">WhatsApp</span>
          <SiWhatsapp className="h-5 w-5" />
        </a>
      </div>
    </div>
  </footer>
);

function App() {
  return (
    <div className="bg-white text-gray-900 antialiased font-sans scroll-smooth">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
